import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Icon, IconComponent } from '@wam/components';

import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cl-icon-badge',
  templateUrl: './icon-badge.component.html',
  styleUrls: ['./icon-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[class.disabled]': 'disabled()' },
  imports: [IconComponent, TranslatePipe],
})
export class IconBadgeComponent {
  readonly icon = input<Icon>();
  readonly size = input('36px');
  readonly object = input(true);
  readonly notificationsCount = input<number>();
  readonly disabled = input(false);

  Icon = Icon;
}
